import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/cloud/cloud-2.svg'
import _imports_1 from '@/assets/svg/testing/phone-qr.svg'
import _imports_2 from '@/assets/svg/testing/phone-svag.svg'


const _hoisted_1 = {
  class: "testing-wrapper",
  id: "testing"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "testing-cloud",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "d-flex flex-column align-items-center" }
const _hoisted_4 = { class: "testing-card position-relative" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-start\"><div class=\"testing-card-text-wrapper\"><div class=\"caps-text text-start\">Протестируй сервис прямо сейчас</div><div class=\"testing-card__text my-3\">Переведите нам 1 рубль и убедитесь, что это очень удобно и просто</div><a class=\"testing__a\" href=\"https://qr.nspk.ru/AS10006QCH7B01SP8CNQ0IO00EJUFAH2?type=01&amp;bank=100000000010&amp;sum=100&amp;cur=RUB&amp;crc=BD58\" target=\"_blank\">Просканируйте код или перейдите по ссылке </a></div></div><img class=\"img-testing-phone-qr\" src=\"" + _imports_1 + "\">", 2)
const _hoisted_7 = { class: "testing__button-wrapper" }
const _hoisted_8 = {
  href: "https://qr.nspk.ru/AS10006QCH7B01SP8CNQ0IO00EJUFAH2?type=01&bank=100000000010&sum=100&cur=RUB&crc=BD58",
  target: "_blank"
}
const _hoisted_9 = { class: "container-l" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Перейти по ссылке")
const _hoisted_11 = { class: "container-s-m" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Перейти по ссылке")
const _hoisted_13 = { class: "testing-card" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-testing-phone-svag",
  src: _imports_2
}, null, -1)
const _hoisted_15 = { class: "d-flex justify-content-end" }
const _hoisted_16 = { class: "testing-card-text-wrapper" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "caps-text text-start" }, "Предоставляем открытый API и виртуальную кассу для теста - бесплатно ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "testing-card__text mt-3" }, "Даем возможность протестировать, насколько «VDCloud» подходит для сервисов, через которые вы осуществляете продажи", -1)
const _hoisted_19 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Протестировать")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, { size: "mini" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                type: "success",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Button, {
                size: "xs",
                onClick: _ctx.openSwag
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ])
  ]))
}